import { useRoutes } from 'react-router-dom'
import { Suspense } from 'react'
import Loading from './components/Loading'
import { routes } from './routes'
import CookieBanner from './components/CookieBanner'

function App() {
  const element = useRoutes(routes)

  return (
    <Suspense fallback={<Loading />}>
      {element}
      <CookieBanner />
    </Suspense>
  )
}

export default App
